/**
 * Rounds a number to a specified number of decimal places.
 *
 * @param {number} value - The number to round.
 * @param {number} decimalCount - The number of decimal places to round to.
 * @returns {number} The rounded number with the specified decimal precision.
 */
export const roundToDecimal = (value: number, decimalCount: number) => {
  const rounder = Math.pow(10, decimalCount);
  return Math.round(value * rounder) / rounder;
};
